import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const RocketLaunch = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ueb9b'}</MuiIcon>
    );
}
